import { render, staticRenderFns } from "./DeleteDraftDiscussion.vue?vue&type=template&id=4b055fe8&scoped=true"
import script from "./DeleteDraftDiscussion.vue?vue&type=script&lang=ts"
export * from "./DeleteDraftDiscussion.vue?vue&type=script&lang=ts"
import style0 from "./DeleteDraftDiscussion.vue?vue&type=style&index=0&id=4b055fe8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b055fe8",
  null
  
)

export default component.exports